import React from 'react';
import { Component, ComponentType } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import apiClient from "../../../framework/web/ApiClient";

interface Course {
    courseId: number;
    courseCode: string;
    courseName: string;
    courseUrl: string;
}

interface State {
    course: Course | null;
    loading: boolean;
    error: string | null;
}

interface CourseProps {
    pathvar?: { id: string };
}

const PAGE_TITLE = "AMS - Course";

class Course extends Component<CourseProps, State> {

    constructor(props: CourseProps) {
        super(props);
        this.state = {
            course: null,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        document.title = PAGE_TITLE;

        let curCourseId = this.#getCourseId();

        if (!curCourseId) {
            curCourseId = this.props.pathvar?.id!;
        }

        if (curCourseId) {
            this.fetchCourse(curCourseId);
        }
    }

    fetchCourse = async (curQuizId: string) => {
        const headers = {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/json"
        };
        apiClient.get('/ams/api/v1/researcher-trainings/courses/' + curQuizId, { withCredentials: true, headers })
            .then(response => {
                if (response.status != 204) {
                    this.setState({ course: response.data.data, loading: false });
                }
            }).catch(error => {
                this.setState({ error: 'Error fetching questions', loading: false });
            });
    };

    #getCourseId(): string {
        let queryParams = new URLSearchParams(window.location.search);
        let courseId = queryParams.get('courseId');
        return courseId || '';
    };

    render() {
        const { course, loading, error } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>{error}</div>;
        }

        return (
            <div className="video-responsive">
                <h2>{course?.courseName}</h2>
                <br />
                <iframe
                    width="1024"
                    height="576"
                    src={`https://www.youtube.com/embed/${course?.courseUrl}`}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
                </iframe>
                <br />
                <a href="/ams/resProfile">
                    <button type="button" className="btn btn-primary">Return to Profile</button>
                </a>
                <br />
            </div>
        )
    };
}

const withNavigation = <P extends object>(WrappedComponent: ComponentType<P>) => {
    return (props: P) => {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        return <WrappedComponent {...props} navigate={navigate} location={location} pathvar={params} />;
    };
};

export default withNavigation(Course);
